import { render, staticRenderFns } from "./opertaionTotSave.vue?vue&type=template&id=0dedbca4&scoped=true"
import script from "./opertaionTotSave.vue?vue&type=script&lang=js"
export * from "./opertaionTotSave.vue?vue&type=script&lang=js"
import style0 from "./opertaionTotSave.vue?vue&type=style&index=0&id=0dedbca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedbca4",
  null
  
)

export default component.exports